import r from 'render-dom';
import styled from 'styled-components';

import Skeleton from 'components/App/Dashboard/ui/Skeleton';

import ProductListSkeleton from '../ProductList/SkeletonLayout';

const AddButton = styled.div`
    box-sizing: border-box;
    padding-bottom: 20px;
    padding-left: 45px;
    padding-right: 45px;
    width: 100%;
`;

const Container = styled.div`
    padding: 0 15px;
`;

const NoPaddingContainer = styled.div`
    margin-top: 11px;
`;

const Header = styled.div`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
`;

const InputWithClear = styled.div`
    position: relative;
    width: 100%;
`;

const PinInstruction = styled.div`
    display: flex;
    font-size: 12px;
    justify-content: center;
    margin: 13px 0;
`;

export default function ProductListSkeletonLayout({ showHeaderSkeleton = true }) {
    const ContainerComponent = showHeaderSkeleton ? Container : NoPaddingContainer;

    return (
        r(ContainerComponent, [
            r.div([
                r(Header, { isRendered: showHeaderSkeleton }, [
                    r(AddButton, [
                        r(Skeleton, { height: '31px', width: '205px' }),
                    ]),
                    r(InputWithClear, [
                        r(Skeleton, { height: '31px', width: '293px' }),
                    ]),
                    r(PinInstruction, [
                        r(Skeleton, { height: '15px', margin: '0px', width: '234px' }),
                    ])
                ]),
                r(ProductListSkeleton),
            ]),
        ])
    );
}
